/**
 * Define local variable `viewportWidth`, which stores window width.
 * We use it as breakpoint to decide showing/hiding specific component
 *
 */

export default {
  data() {
    return {
      viewportWidth: undefined,
    };
  },
  // update the variable while window resize
  methods: {
    // whenever the document is resized, re-set the 'viewportWidth' variable
    handleResize() {
      this.viewportWidth = Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0);
    },
  },
  mounted: function() {
    // Get viewport width so we can determine which subcomponent to render
    this.viewportWidth = Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0);
    window.addEventListener('resize', this.handleResize);
  },
};
